import PropTypes from 'prop-types';

const TemplatePreviewPropType = {
  classes: PropTypes.instanceOf(Object),
};

export default TemplatePreviewPropType;
